import ToggleSwitch from "aldoo-ra/ToggleSwitch"

export default function BillingToggle({ billing, setBilling, texts }) {
  return (
    <div className="relative w-fit flex items-center justify-center gap-3 border border-theme_white bg-gradient-to-br from-primary/[0.03] via-paper to-paper/50 rounded-full px-4 sm:px-6 py-2 md:py-3 mb-10 mx-auto">
      <span
        className={`text-sm md:text-base xl:text-lg font-medium cursor-pointer transition-color duration-700 ${
          billing === "monthly" ? "text-text" : "text-text_secondary"
        }`}
        onClick={() => setBilling("monthly")}
      >
        {texts?.billing_monthly_label}
      </span>

      <ToggleSwitch
        isOn={billing === "annual"}
        onChange={(val) => setBilling(val ? "annual" : "monthly")}
      />

      <span
        className={`flex items-center text-sm md:text-base  xl:text-lg font-medium cursor-pointer transition-color duration-700 ${
          billing === "annual" ? "text-text" : "text-text_secondary"
        }`}
        onClick={() => setBilling("annual")}
      >
        {texts?.billing_annual_label}

        <span className="absolute sm:relative -top-4 right-3 sm:top-auto sm:right-auto text-xs text-white font-bold whitespace-nowrap rounded-full bg-gradient-to-br from-secondary to-accent px-2 py-1 ml-2">
          {texts?.billing_annual_discount_badge}
        </span>
      </span>
    </div>
  )
}